import { render, staticRenderFns } from "./receiveCar.vue?vue&type=template&id=8151f20e&scoped=true&"
import script from "./receiveCar.vue?vue&type=script&lang=js&"
export * from "./receiveCar.vue?vue&type=script&lang=js&"
import style0 from "./receiveCar.vue?vue&type=style&index=0&id=8151f20e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8151f20e",
  null
  
)

export default component.exports